import { OfferType } from '@smg-real-estate/hg-rets-schema';
import { AgencyBasePackage, ListerBranding } from '@smg-real-estate/hg-search-libs';

import hgGoldPartnerBadge from '@/assets/partnerBadge/HG-Gold-Partner.svg?url';
import hgSilverPartnerBadge from '@/assets/partnerBadge/HG-Silver-Partner.svg?url';
import is24GoldPartnerBadge from '@/assets/partnerBadge/IS24-Gold-Partner.svg?url';
import is24SilverPartnerBadge from '@/assets/partnerBadge/IS24-Silver-Partner.svg?url';
import { isPlatformIs24 } from '@/helpers/platformDetection';

export interface PartnerBadge {
  src: string;
  alt: string;
}

export function getPartnerBadge(
  offerType: OfferType | undefined,
  listerBranding: ListerBranding | null | undefined,
  isPartnerBadgeEnabled: boolean,
): PartnerBadge | null {
  if (!isPartnerBadgeEnabled || offerType !== OfferType.Buy) {
    return null;
  }

  const basePackage = listerBranding?.basePackage?.trim();
  const isIs24 = isPlatformIs24();

  if (basePackage === AgencyBasePackage.RE_GOLD) {
    return {
      src: isIs24 ? is24GoldPartnerBadge : hgGoldPartnerBadge,
      alt: 'Gold Partner',
    };
  }

  if (basePackage === AgencyBasePackage.RE_SILVER) {
    return {
      src: isIs24 ? is24SilverPartnerBadge : hgSilverPartnerBadge,
      alt: 'Silver Partner',
    };
  }

  return null;
}
